module.exports = __webpack_public_path__ + "static/media/youtube.19a9961d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/youtube.svg
// module id = 357
// module chunks = 25